"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePurchaseOrderInvoicedStatus = exports.calculateItemInvoicedStatus = exports.calculatePurchaseOrderDeliveryStatus = exports.calculateItemDeliveryStatus = exports.calculateTotalQuantityReceived = exports.calculateTotalAmountInvoiced = void 0;
const dinero = __importStar(require("dinero.js"));
const models_1 = require("../models");
const lineItem_validation_1 = require("../models/purchaseOrder/lineItem.validation");
const common_1 = require("./common");
const calculateTotalAmountInvoiced = (lineItem) => { var _a, _b; return (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.invoiceLinks) === null || _a === void 0 ? void 0 : _a.reduce((acc, link) => acc + link.amountInvoiced, 0)) !== null && _b !== void 0 ? _b : 0; };
exports.calculateTotalAmountInvoiced = calculateTotalAmountInvoiced;
const calculateTotalQuantityReceived = (lineItem) => { var _a, _b; return (_b = (_a = lineItem === null || lineItem === void 0 ? void 0 : lineItem.deliveryNotes) === null || _a === void 0 ? void 0 : _a.reduce((acc, note) => acc + note.quantityReceived, 0)) !== null && _b !== void 0 ? _b : 0; };
exports.calculateTotalQuantityReceived = calculateTotalQuantityReceived;
const calculateItemDeliveryStatus = (lineItem) => {
    const quantityReceived = (0, exports.calculateTotalQuantityReceived)(lineItem);
    const isGreaterThanOrEqualQuantity = dinero
        .default({ amount: Math.round(quantityReceived * Math.pow(10, lineItem_validation_1.LINE_ITEM_QUANTITY_MAX_DECIMAL_PLACES)), precision: lineItem_validation_1.LINE_ITEM_QUANTITY_MAX_DECIMAL_PLACES })
        .greaterThanOrEqual(dinero.default({ amount: Math.round(lineItem.quantity * Math.pow(10, lineItem_validation_1.LINE_ITEM_QUANTITY_MAX_DECIMAL_PLACES)), precision: lineItem_validation_1.LINE_ITEM_QUANTITY_MAX_DECIMAL_PLACES }));
    if (isGreaterThanOrEqualQuantity) {
        return models_1.PurchaseOrderDeliveryStatusEnum.FULLY_DELIVERED;
    }
    if (quantityReceived > 0) {
        return models_1.PurchaseOrderDeliveryStatusEnum.PARTIALLY_DELIVERED;
    }
    return models_1.PurchaseOrderDeliveryStatusEnum.NOT_DELIVERED;
};
exports.calculateItemDeliveryStatus = calculateItemDeliveryStatus;
const calculatePurchaseOrderDeliveryStatus = (lineItems) => {
    const statuses = lineItems.map((item) => (0, exports.calculateItemDeliveryStatus)(item));
    if (statuses.every((status) => status === models_1.PurchaseOrderDeliveryStatusEnum.FULLY_DELIVERED)) {
        return models_1.PurchaseOrderDeliveryStatusEnum.FULLY_DELIVERED;
    }
    if (statuses.every((status) => status === models_1.PurchaseOrderDeliveryStatusEnum.NOT_DELIVERED)) {
        return models_1.PurchaseOrderDeliveryStatusEnum.NOT_DELIVERED;
    }
    return models_1.PurchaseOrderDeliveryStatusEnum.PARTIALLY_DELIVERED;
};
exports.calculatePurchaseOrderDeliveryStatus = calculatePurchaseOrderDeliveryStatus;
const calculateItemInvoicedStatus = (lineItem) => {
    const totalAmountInvoiced = (0, exports.calculateTotalAmountInvoiced)(lineItem);
    const isGreaterThanOrEqualAmount = (0, common_1.toDinero)(totalAmountInvoiced).greaterThanOrEqual((0, common_1.toDinero)(lineItem.totalGrossPrice));
    if (isGreaterThanOrEqualAmount) {
        return models_1.PurchaseOrderInvoicedStatusEnum.FULLY_INVOICED;
    }
    if (totalAmountInvoiced > 0) {
        return models_1.PurchaseOrderInvoicedStatusEnum.PARTIALLY_INVOICED;
    }
    return models_1.PurchaseOrderInvoicedStatusEnum.NOT_INVOICED;
};
exports.calculateItemInvoicedStatus = calculateItemInvoicedStatus;
const calculatePurchaseOrderInvoicedStatus = (lineItems) => {
    const statuses = lineItems.map((item) => (0, exports.calculateItemInvoicedStatus)(item));
    if (statuses.every((status) => status === models_1.PurchaseOrderInvoicedStatusEnum.FULLY_INVOICED)) {
        return models_1.PurchaseOrderInvoicedStatusEnum.FULLY_INVOICED;
    }
    if (statuses.every((status) => status === models_1.PurchaseOrderInvoicedStatusEnum.NOT_INVOICED)) {
        return models_1.PurchaseOrderInvoicedStatusEnum.NOT_INVOICED;
    }
    return models_1.PurchaseOrderInvoicedStatusEnum.PARTIALLY_INVOICED;
};
exports.calculatePurchaseOrderInvoicedStatus = calculatePurchaseOrderInvoicedStatus;
